// SidebarMenuMain.tsx
import React, { useState } from 'react';
import { SidebarMenuItem } from './SidebarMenuItem';
import SearchBarFilter from '../../search/SearchBarFilter';
import menuItems from '../../AsideData.json';
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';
import { getRolesFromToken } from '../../../../../app/JwtDecode';


const SidebarMenuMain: React.FC = () => {
  const [filteredItems, setFilteredItems] = useState(menuItems);
  const userRoleGroups = getRolesFromToken();
  if (userRoleGroups === null)
    window.location.href = "/login";

  const handleSearch = (searchTerm: string) => {
    const filtered = menuItems.filter(item =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredItems(filtered);
  };
  const generatePath = (fileName: string) => {
    return "/media/icons/" + fileName
  }
  // Kullanıcının rollerini değerlendirerek menü öğelerini filtrele
  const filteredForUserRole = filteredItems.filter(item => {
    if (item.role) {
      const roles = item.role.split(',').map(role => role.trim());
      return roles.some(role => userRoleGroups!.includes(role));
    }
    return true; // Eğer role belirtilmemişse öğeyi göster
  });

  return (
    <>
      <div>
        <SearchBarFilter onFilter={handleSearch} />

        {/* Filtrelenmiş öğeleri haritala */}
        {filteredForUserRole.map((item) => (
          <div style={{ borderBottom: '1px solid #F2F4F8' }} key={item.index}>
            {item.children ? (
              <SidebarMenuItemWithSub
                key={item.index}
                to={item.to}
                title={item.title}
                hint={item["hint"]}
                icon={item["icon"] ? generatePath(item["icon"]) : undefined}
                fontIcon={item["fontIcon"]}
                hasBullet={false}
              >
                {item.children.map((childItem) => (
                  <SidebarMenuItem
                    key={childItem.index}
                    to={childItem.to}
                    title={childItem.title}
                    hint={childItem["hint"]}
                    icon={childItem["icon"] ? generatePath(childItem["icon"]) : undefined}
                    fontIcon={childItem["fontIcon"]}
                  />
                ))}
              </SidebarMenuItemWithSub>
            ) : (
              <SidebarMenuItem
                key={item.index}
                to={item.to}
                title={item.title}
                hint={item["hint"]}
                icon={item["icon"] ? generatePath(item["icon"]) : undefined}
                fontIcon={item["fontIcon"]}
              />
            )}
          </div>
        ))}
      </div>
    </>
  );
}

export { SidebarMenuMain };
